import {
    SET_IS_FETCHING_PICKERS,
    SET_PICKERS,
    SET_PICKERS_ALL_CHUNKS_LOADED,
    SET_PICKERS_LOADED_CHUNK_INDEXES,
    SET_PICKERS_TOTAL,
    SET_PICKERS_TOTAL_CHUNKS,
} from 'reducers/actions-types';
import axios from 'axios';
import { dispatchError } from 'reducers/helpers';
import { pickers } from 'constants/api-urls';
import { indexOf, sample } from 'lodash';

export function getUniqueRandom(allChunks) {
    if (allChunks.length <= 0) {
        return null;
    }

    return sample(allChunks);
}

export function buildChunkIndexes(total, exclude) {
    const chunks = [];
    for (let i = 0; i < total; i++) {
        if (indexOf(exclude, i) === -1) {
            chunks.push(i);
        }
    }

    return chunks;
}

export function getNextChunkIndex(totalChunks, loadedChunkIndexes = []) {
    const allChunks = buildChunkIndexes(totalChunks, loadedChunkIndexes);
    return getUniqueRandom(allChunks);
}

export function fetchNextChunk() {
    return function(dispatch, getState) {
        const { loadedChunkIndexes, totalChunks } = getState().pickers;
        const nextChunk = getNextChunkIndex(totalChunks, loadedChunkIndexes);

        if (nextChunk === null) {
            return null;
        }

        return request(null, nextChunk, true)(dispatch, getState);
    };
}

export function request(requestData, chunkIndex = null, appendResult = false) {
    return function(dispatch, getState) {
        const { chunkSize } = getState().pickers;
        let { items, loadedChunkIndexes } = getState().pickers;
        const url = pickers(chunkSize, chunkIndex);

        dispatch({ type: SET_IS_FETCHING_PICKERS, isFetching: true });

        return axios[requestData ? 'post' : 'get'](url, requestData)
            .then(
                /**
                 * @param {IPickerLoadResponse} data
                 */
                ({ data }) => {
                    let pickerItems = data.pickers;
                    const total = data.total_count;
                    const totalChunks = data.chunks_total;
                    const currentChunkIndex = data.chunk_index;

                    if (appendResult) {
                        items = items.concat(pickerItems);
                    } else {
                        items = pickerItems;
                        loadedChunkIndexes = [];
                    }

                    loadedChunkIndexes.push(currentChunkIndex);

                    dispatch({ type: SET_PICKERS, items });
                    dispatch({ type: SET_PICKERS_TOTAL, total });
                    dispatch({ type: SET_PICKERS_TOTAL_CHUNKS, totalChunks });
                    dispatch({ type: SET_PICKERS_LOADED_CHUNK_INDEXES, loadedChunkIndexes });
                    dispatch({ type: SET_IS_FETCHING_PICKERS, isFetching: false });

                    const loadedAllChunks = loadedChunkIndexes.length >= totalChunks;

                    dispatch({
                        type: SET_PICKERS_ALL_CHUNKS_LOADED,
                        loadedAllChunks: loadedAllChunks,
                    });
                })
            .catch((e) => {
                dispatch({ type: SET_IS_FETCHING_PICKERS, isFetching: false });
                dispatchError(dispatch, e, {
                    url: pickers(),
                    description: e.message,
                    error: e,
                    reloadButton: true,
                });
            });
    };
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/pickers/helpers.js